import {SectionTemplateDto} from './SectionTemplate';
import {ReportType} from "./ReportType";

export interface PreviewPage {
  name: string;
  previewId: string;
}

export interface ThemeDto{
  id: string;
  name: string;
  type: ReportType;
  tenant: string[];
  description: string;
  tocTypes: string[];
  sectionTemplates: SectionTemplateDto[];
  chartPalette: Palette;
  fileName: string;
  idsFileId: string;
  previewId: string;
  previewPages: PreviewPage[];
}

export interface CssTemplateDto {
    id: any;
    name: string;
    tenant: string[];
    reportType: string[];
    description?: string;
    body: string;
}

export class ChartTemplate {
    id: any;
    tenant?: string[];
    description?: string;
    name?: string;
    reportType?: string[];
    jsonString: string|any;
}

export interface CssTemplateVersionDto {
    content: string;
    createdOn: number;
    createdBy: string;
}

export interface Palette {
  colors: Color[];
}

export interface Color {
  red: number;
  green: number;
  blue: number;
  alpha: number;
}

export interface TenantOption {
    displayName: string;
    value: string;
}


